import { render, staticRenderFns } from "./GameList.vue?vue&type=template&id=4d5850df&scoped=true"
import script from "./GameList.vue?vue&type=script&lang=js"
export * from "./GameList.vue?vue&type=script&lang=js"
import style0 from "./GameList.vue?vue&type=style&index=0&id=4d5850df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5850df",
  null
  
)

export default component.exports